import { useImperativeHandle } from "react";
import { useFormContext } from "react-hook-form";

const AutoSave = (ref, requiredFields, submitCallback) => {
    const { trigger, getValues } = useFormContext();

    useImperativeHandle(ref, () => ({
        submitAndCheck: async () => {
            const isValid = await trigger(requiredFields);

            if (isValid) {
                await submitCallback(getValues());
                return true;
            } else {
                return false;
            }
        }
    }));
}

export default AutoSave;